// extracted by mini-css-extract-plugin
export default {"rating":"UI-z","numberOfStars":"VI-z","count":"WI-z","barGraphSpacing":"XI-z","barGraph":"YI-z"};